import { DrumStepGrid } from './DrumStepGrid';
import type { DrumId, DrumPattern } from '../types';

interface Props {
  open: boolean;
  pattern: DrumPattern;
  activeStep: number | null;
  onClose: () => void;
  onPatternChange: (next: DrumPattern) => void;
  onToggleStep: (drum: DrumId, stepIndex: number) => void;
  onClearRow: (drum: DrumId) => void;
  onMeasuresChange: (measures: number) => void;
}

export function DrumAccompanimentPanel({
  open,
  pattern,
  activeStep,
  onClose,
  onPatternChange,
  onToggleStep,
  onClearRow,
  onMeasuresChange,
}: Props) {
  if (!open) return null;

  return (
    <div className="drum-panel-backdrop" role="presentation" onClick={onClose}>
      <div
        className="drum-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="drum-panel-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="drum-panel__header">
          <div>
            <h2 id="drum-panel-title" className="drum-panel__title">
              Acompañamiento rítmico
            </h2>
            <p className="drum-panel__subtitle">
              Arma tu loop de batería. Se repite mientras suena el patrón de boomwhackers.
            </p>
          </div>
          <button
            type="button"
            className="drum-panel__close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ×
          </button>
        </header>

        <div className="drum-panel__toolbar">
          <label className="drum-panel__field">
            Compases del loop
            <select
              value={pattern.measures}
              onChange={(e) => onMeasuresChange(Number(e.target.value))}
            >
              {[1, 2, 3, 4].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>

          <label className="drum-panel__toggle">
            <input
              type="checkbox"
              checked={pattern.enabled}
              onChange={(e) =>
                onPatternChange({ ...pattern, enabled: e.target.checked })
              }
            />
            Usar al reproducir
          </label>
        </div>

        <div className="drum-panel__grid-wrap">
          <DrumStepGrid
            pattern={pattern}
            activeStep={activeStep}
            onToggleStep={onToggleStep}
            onClearRow={onClearRow}
          />
        </div>

        <footer className="drum-panel__footer">
          <p className="drum-panel__hint">
            Cada columna es una semicorchea. Los números marcan los tiempos del compás.
          </p>
          <button type="button" className="btn btn-play" onClick={onClose}>
            Listo
          </button>
        </footer>
      </div>
    </div>
  );
}
